module.exports = "/images/general.svg?1253bb8e8d5938904c57dff22ea16175";